// extracted by mini-css-extract-plugin
export default {"list":"Menu_list__muoX4","link":"Menu_link__4GWKg","linkActive":"Menu_linkActive__daRCS","linkLogout":"Menu_linkLogout__JYj8u","nav":"Menu_nav__H7TuE"};